<template>
  <div v-if="recibido" class="confirmacion">
    <!-- <el-dialog
      :visible.sync="recibido"
      width="360px"
      :top="'3vh'"
      :center="true"
      custom-class="modal-inner confirmacion"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="false"
   
    :modal="true"
    > -->
    <h3>Confirmación</h3>
   <p>
     Necesitamos que nos confirmes que ya tenés el pedido para poder realizar un reclamo por los productos del mismo.
   </p>
   <!-- <small>El reclamo quedará sujeto a la validación de la farmacia</small> -->
   <el-button type="verde" size="default" @click="regresar">Regresar</el-button>
   <el-button type="primary" size="default" :loading="procesando" @click="confirmar">Lo tengo</el-button>
   
    <!-- </el-dialog> -->
  </div>
</template>

<script>

import { EventBus } from "@/event-bus";
import { HTTP } from "@/axios";
export default {
  props:['datos'],
  data() {
    return {
      recibido: false,
      recopilando: true,
      procesando:false
    };
  },
  created() {
    EventBus.$on("ModalConfirmarRecepcion", (d) => {
      if(d && d.id)
       {
         this.recibido = true
       }else{
this.recibido = false;
       }

      
      // this.cancelar(d)
    });
    //   EventBus.$on('enviarFormCancelar', (m) => {
    //       this.cancelar(m)
    //   })
  },

  methods: {
    confirmar()
    {
      this.procesando = true
       let datos ={
         vtex_id : this.datos.vtex_id,
         estado_desde:30,
         estado_hasta:40,
         cliente:this.datos.cliente
       }
       HTTP.post('/confirmarRetiro',datos)
           .then(res => {
      this.procesando = false
             EventBus.$emit('cambiarEstado',40)
           })
           .catch(() =>{
      this.procesando = false
           })
    },
    verForm() {
      EventBus.$emit("openForm", true);
    },
   

    regresarMobile() {
      EventBus.$emit("isMobile", false);
      EventBus.$emit("cerrarDemorado", false);
      this.recibido = false;
    },
    regresar() {
      EventBus.$emit("cerrarDemorado", false);
      this.recibido = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.confirmacion{
  text-align: left;
  padding: 20px;
}
.confirmacion h3 {
  // margin:0px;
  color: #333;

}
.confirmacion p {
  font-size: 16px;
  line-height: 1.2;
  color: #333;
  // padding: 10px;
}
</style>